import React from 'react'
import { styled, Grid as BaseGrid } from '@mui/material'

export const Container = styled(({ children, display, float, width, ...props }) => (
  <BaseGrid container {...props}>
    {children}
  </BaseGrid>
))`
  &.MuiGrid-container {
    display: ${props => props.display};
    float: ${props => props.float};
    width: ${props => props.width};
  }
`

export const Item = styled(({ children, width, ...props }) => (
  <BaseGrid item {...props}>
    {children}
  </BaseGrid>
))`
  width: ${props => props.width};
`

export const Logo = styled('img')`
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 215px;
`

export const LogoLink = styled('a')`
  cursor: pointer;
  float: left;
  margin: 0 20px 0 0;
`

export const Root = styled('div')`
  display: flex;
  height: auto;
  margin: 0;
  width: 100%;
`
